import React from "react";
import "./ProductInfo.css";
import { useNavigate } from "react-router-dom";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";
import { useCart } from "../../context/CartContext";
import { addToCartAlert } from "../../utils/alerts";

export default function ProductInfo({ product, selectedVariant, setSelectedVariant }) {

    // if (!product) return null;
    const navigate = useNavigate();
    const { addItem, isInCart } = useCart();

    const variants = product.variants || [];

    // --- STEP 1: Extract all sizes and colors ---
    const allSizes = [...new Set(variants.map(v => v.size).filter(Boolean))];
    const allColors = [...new Set(variants.map(v => v.color).filter(Boolean))];

    const hasSizes = allSizes.length > 0;
    const hasColors = allColors.length > 0;

    // --- STEP 2: Colors available for selected size ---
    let availableColors = [];
    if (hasSizes && selectedVariant?.size) {
        availableColors = variants
            .filter(v => v.size === selectedVariant.size && v.color)
            .map(v => ({
                color: v.color,
                image: v?.images[0]?.image || "https://via.placeholder.com/36" // fallback image
            }));
        // Remove duplicates by color
        availableColors = [...new Map(availableColors.map(c => [c.color, c])).values()];
    }

    // --- SELECT SIZE ---
    const selectSize = (size) => {
        let found = null;
        if (hasColors) {
            // Find first variant with this size and any available color
            found = variants.find(v => v.size === size);
        } else {
            // No color → match by size only
            found = variants.find(v => v.size === size);
        }

        if (found) setSelectedVariant(found);
    };

    // --- SELECT COLOR ---
    const selectColor = (color) => {
        // Match current selected size with clicked color
        const found = variants.find(
            v => v.size === selectedVariant.size && v.color === color
        );
        if (found) setSelectedVariant(found);
    };

    const price = selectedVariant?.price ?? product.price ?? 0;
    const stock = selectedVariant?.stock ?? product.stock ?? 0;

    const alreadyInCart = isInCart(
        product?.slug,
        selectedVariant?.color,
        selectedVariant?.size
    );

    const handleAddToCart = () => {
        if (alreadyInCart) {
            navigate("/cart"); // 2nd click
            return;
        }

        addItem(
            {
                slug: product?.slug,
                image: product?.mainImage,
                categorySlug: product?.category,
                subCategorySlug: product?.subCategory,
                brand: product?.brand,
                color: selectedVariant?.color,
                size: selectedVariant?.size,
                productName: product?.productName,
                price: selectedVariant?.price ?? product?.price ?? 0,
                stock: selectedVariant?.stock ?? product?.stock ?? 0,
            },
        );

        addToCartAlert(); // 1st click
    };
    return (
        <div className="product-info mb-2">

            <h6 className="product-brand mb-1 mb-md-2">{product.brand}</h6>

            <h2 className="product-name mb-3 mb-md-4">
                {product.productName}
            </h2>

            <button
                className="btn add-to-cart w-100 w-md-auto"
                disabled={stock === 0}
                onClick={handleAddToCart}
            >
                Add to Cart
            </button>

            {/* Price */}
            {/* <p className="product-price">${price.toFixed(2)}</p> */}

            {/* Stock */}
            {/* <p className={`availability ${stock > 0 ? "in-stock" : "out-stock"}`}>
                {stock > 0 ? <CheckCircleIcon /> : <CancelIcon />}
                {stock > 0 ? "In Stock" : "Out of Stock"}
            </p> */}

            {/* VARIANTS SECTION */}
            {/* <div className="variants">

               SIZE SECTION */}
            {/* {hasSizes && (
                    <div className="sizes">
                        <h6>Size: {selectedVariant?.size}</h6>
                        <div className="size-options">
                            {allSizes.map((s, i) => (
                                <button
                                    key={i}
                                    className={selectedVariant?.size === s ? "active" : ""}
                                    onClick={() => selectSize(s)}
                                >
                                    {s}
                                </button>
                            ))}
                        </div>
                    </div>
                )} */}

            {/* COLOR SECTION */}
            {/* {availableColors.length > 0 && (
                    <div className="colors">
                        <h6>Color: {selectedVariant?.color}</h6>
                        <div className="color-options">
                            {availableColors.map((c, i) => (
                                <button
                                    key={i}
                                    className={selectedVariant?.color === c?.color ? "active" : ""}
                                    onClick={() => selectColor(c.color)}
                                >
                                    <img src={c.image} alt={c.color} style={{ height: "40px", width: "auto" }} />
                                </button>
                            ))}
                        </div>
                    </div>
                )} 

            </div>*/}
        </div>
    );
}
